// Utility to parse messages and extract code blocks
export const parseMessageContent = (content) => {
  const parts = [];
  const codeBlockRegex = /```(\w+)?\n([\s\S]*?)```/g;
  let lastIndex = 0;
  let match;

  while ((match = codeBlockRegex.exec(content)) !== null) {
    // Add text before code block
    if (match.index > lastIndex) {
      const text = content.substring(lastIndex, match.index).trim();
      if (text) {
        parts.push({
          type: 'text',
          content: text
        });
      }
    }

    // Add code block
    const language = match[1] || 'plaintext';
    const code = match[2].trim();
    
    // Check if it's a diff by looking for diff markers
    const isDiff = code.includes('\n+') || code.includes('\n-') || code.includes('\n@@');
    
    parts.push({
      type: 'code',
      language: language,
      content: code,
      isDiff: isDiff
    });

    lastIndex = match.index + match[0].length;
  }

  // Add remaining text after last code block
  if (lastIndex < content.length) {
    const text = content.substring(lastIndex).trim();
    if (text) {
      parts.push({
        type: 'text',
        content: text
      });
    }
  }

  // If no code blocks found, return the entire content as text
  if (parts.length === 0) {
    parts.push({
      type: 'text',
      content: content
    });
  }

  return parts;
};

// Extract filename from code content or context
export const extractFilename = (code, language) => {
  // Look for common filename patterns in the code
  const filenamePatterns = [
    /\/\/ File: (.+)$/m,
    /# File: (.+)$/m,
    /\/\* File: (.+) \*\//,
    /<!-- File: (.+) -->/
  ];

  for (const pattern of filenamePatterns) {
    const match = code.match(pattern);
    if (match) {
      return match[1].trim();
    }
  }

  // Return null if no filename found
  return null;
}; 